import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, SelectField, Option,  Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@deere/fuel-react";
import { DEFAULT_LANGUAGE_ENGLISH, DEFAULT_LANGUAGE_CODE, ADD_NEW_LINK, LINK_LABEL_PLACEHOLDER, LINK_PLACEHOLDER, LINK_LABEL_LABEL, LINK_LABEL_LANGUAGE, LINK_LABEL_LINK, DESCRIPTION, LONG_DESCRIPTION, SELECT  } from "../../../../utils/surveyLiterals";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
const LinksTab = ({ section, payloadData, setPayloadData, setSectionError }) => {
    const [langSelectionLocal, setLangSelectionLocal] = useState([]);

    useEffect(() => {
      if (langSelectionLocal.length === 0) {
        const sectionIndex = payloadData.sections.findIndex((sec) => sec.code === section.code);
        const links = sectionIndex > -1 ? payloadData.sections[sectionIndex].links : [];
        if (links.length > 0) {
          const langSelection = links.map((l) => {
            return {showOrder: l.showOrder, langSelection: DEFAULT_LANGUAGE_CODE};
          })
          setLangSelectionLocal(langSelection);
        }
      }
    }, [langSelectionLocal.length]);

    const addNewhandler = () => {
      let showOrderTemp = "";
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((sec) => sec.code === section.code);
        const newSections = [...prevState.sections];
        const newLinks = [...newSections[sectionIndex].links];
        const newTranslations = [];
        payloadData.language.forEach((l)=>{
          if(l.languageCd!==DEFAULT_LANGUAGE_CODE){
            newTranslations.push({locale: l.languageCd, text: "", url: ""})
          }
        })
        newLinks.push({text: "", url: "", showOrder: section.links.length+1, translations: newTranslations});
        showOrderTemp = section.links.length+1
        newSections[sectionIndex] = { ...newSections[sectionIndex], links: newLinks };
        return { ...prevState, sections: newSections };
      });
      setLangSelectionLocal((prevState) => {
        const newState = [...prevState];
        newState.push({showOrder: showOrderTemp, langSelection: DEFAULT_LANGUAGE_CODE});
        return [...newState];
      })
      setSectionError({ show: false, message: "" });
    };

    const updateLangSelection = (e, link) => {
      setLangSelectionLocal((prevState) => {
        const newState = [...prevState];
        const index = newState.findIndex((ps) => ps.showOrder === link.showOrder);
        if(index > -1)  newState[index].langSelection = e.target.value;
        return [...newState];
      })
    };

    const fetchLangSelectionValue = (link) => {
      const index = langSelectionLocal.findIndex((lsl) => lsl.showOrder === link.showOrder);
      return index > -1 ? langSelectionLocal[index].langSelection : "";
    };

    const fetchValue = (link, field) => {
      const langSelectionIndex = langSelectionLocal.findIndex((lsl) => lsl.showOrder === link.showOrder);
      const langToUpdate = langSelectionIndex > -1 ? langSelectionLocal[langSelectionIndex].langSelection : "";
      let value = ""
      switch (field) {
        case DESCRIPTION:
          if (langToUpdate === DEFAULT_LANGUAGE_CODE) value = link.text;
          else {
            const index = link.translations.findIndex((lt) => lt.locale === langToUpdate);
            value = index > -1 ? link.translations[index].text : ""
          }
          break;
        case LONG_DESCRIPTION:
          if (langToUpdate === DEFAULT_LANGUAGE_CODE) value = link.url;
          else {
            const index = link.translations.findIndex((lt) => lt.locale === langToUpdate);
            value = index > -1 ? link.translations[index].url : ""
          }
          break;
      }
      return value;
    };

    const changeHandler = (e, link) => {
      const localLangIndex = langSelectionLocal.findIndex((lsl) => lsl.showOrder === link.showOrder);
      const langToUpdate = langSelectionLocal[localLangIndex].langSelection;
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((sec) => sec.code === section.code);
        const newSections = [...prevState.sections];
        const newLinks = [...newSections[sectionIndex].links];
        const newLinksIndex = newLinks.findIndex((li) => li.showOrder === link.showOrder);
        const trIndex = newLinks[newLinksIndex].translations.findIndex((tr) => tr.locale === langToUpdate);
        switch (e.target.name) {
          case DESCRIPTION:
            if(newLinks[newLinksIndex]){
              if (langToUpdate === DEFAULT_LANGUAGE_CODE){
                newLinks[newLinksIndex].text = e.target.value;
              } else if (trIndex > -1) {
                newLinks[newLinksIndex].translations[trIndex].text = e.target.value;
              }
            }
            break;
          case LONG_DESCRIPTION:
            if(newLinks[newLinksIndex]){
              if(langToUpdate === DEFAULT_LANGUAGE_CODE){
                newLinks[newLinksIndex].url = e.target.value;
              } else if (trIndex > -1) {
                newLinks[newLinksIndex].translations[trIndex].url = e.target.value;
              }
            }
            break;
        }
        newSections[sectionIndex] = { ...newSections[sectionIndex], links: newLinks};
        return { ...prevState, sections: newSections };
      });
    };

    const deleteLink = (link) => {
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((s) => s.code === section.code);
        const newSections = [...prevState.sections];
        const newLinks = [...newSections[sectionIndex].links].filter((li) => li.showOrder !== link?.showOrder);
        newLinks.forEach((li) => {
          if (li.showOrder > link.showOrder){
            const linkCount = li.showOrder - 1;
            li.showOrder = linkCount;
          }
        })
        newSections[sectionIndex] = {...newSections[sectionIndex], links: newLinks};
        return { ...prevState, sections: newSections };
      });
      setLangSelectionLocal((prevState) => {
        const newState = prevState.filter((ps) => ps.showOrder !== link?.showOrder);
        newState.forEach((item) => {
          if (item.showOrder > link.showOrder) {
            const linkCount = item.showOrder - 1;
            item.showOrder = linkCount;
          }
        });
        return newState;
      });
      setSectionError({ show: false, message: "" });
    };
  return (
    <div>
    <Grid container mt={4} spacing={4}>
    <Table size="small">
      {
        payloadData &&
        payloadData.sections &&
        payloadData.sections.length > 0 &&
      <>
      {section?.links?.length>0? (
          <TableHead sx={{ border: "none" }}>
            <TableRow>
              <TableCell>{LINK_LABEL_LABEL}</TableCell>
              <TableCell>{LINK_LABEL_LINK}</TableCell>
              <TableCell>{LINK_LABEL_LANGUAGE}</TableCell>
            </TableRow>
          </TableHead>
      ) :null
      }
      <TableBody>
        {
          section?.links?.map((link, index) => (
            <TableRow key={index} sx={{ border: "none!important" }}>
              <TableCell>
                <TextField name={DESCRIPTION}  placeholder={LINK_LABEL_PLACEHOLDER} onChange={(e) => changeHandler(e, link)} value={fetchValue(link, DESCRIPTION)} />
              </TableCell>
              <TableCell>
                <TextField name={LONG_DESCRIPTION}  placeholder={LINK_PLACEHOLDER} onChange={(e) => changeHandler(e, link)} value={fetchValue(link, LONG_DESCRIPTION)} />
              </TableCell>
              <TableCell>
                <SelectField
                      name={LINK_LABEL_LANGUAGE}
                      sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
                      onChange={(e) => updateLangSelection(e, link)}
                      value={fetchLangSelectionValue(link)}
                >
                  <Option disabled hidden>
                    {DEFAULT_LANGUAGE_ENGLISH}
                  </Option>
                  {payloadData.language.map((lang) => (
                      <Option key={lang.languageCd} value={lang.languageCd}>
                        {lang.text}
                      </Option>
                    ))}
                </SelectField>
              </TableCell>
              <TableCell>
                <IconButton aria-label="Delete" onClick={() => deleteLink(link)}>
                    <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          )) 
        }
      </TableBody>
      </>
      }
      </Table>
      </Grid>
    <br/>
    <Button variant="primary" onClick={addNewhandler} style={{ width: "20%", margin: "0px auto 0px 0px" }}>
      {ADD_NEW_LINK}
    </Button>
    </div>
  );
};

export default LinksTab;